<div class="bg-card shadow rounded-2xl p-4 m-4" style="width: 98%;">
    <div class="text-2xl text-center font-medium tracking-tight leading-6 mb-6 truncate">
        Automated Audit Trail
    </div>

    <div class="grid grid-cols-2 gap-2 py-3">

        <div class="flex justify-start">
            <div class="w-18 mx-2">
                <mat-form-field class="w-full">
                    <mat-select [(ngModel)]="filterData.pageSize" (selectionChange)="onWellSelectionChange()">
                        <ng-container *ngFor="let pageSize of pageSizeList">
                            <mat-option [value]="pageSize">
                                {{ pageSize }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
            <button
                class="btn btn-outline btn-default dt-download mx-2"
                [matMenuTriggerFor]="downloadMenu"
            >
                <mat-icon
                    class="text-primary hover:text-white"
                    svgIcon="heroicons_solid:arrow-down-tray"
                ></mat-icon>
            </button>
            <mat-menu #downloadMenu="matMenu">
                <button mat-menu-item>Excel</button>
                <button mat-menu-item>PDF</button>
            </mat-menu>
        </div>

        <div class="flex justify-end">
            <ng-container *ngIf="(auditTrailsData$ | async) as auditTrailsData">
                <div class="w-48 mr-4">
                    <mat-form-field class="w-full">
                        <mat-select placeholder="Well Name" [(ngModel)]="filterData.wellName"
                            (selectionChange)="onWellSelectionChange()" style="color: red;">
                            <mat-option [value]="'all'">
                                All
                            </mat-option>
                            <ng-container *ngFor="let wellName of auditTrailsData.data.wellNames">
                                <ng-container *ngIf="wellName != ''">
                                    <mat-option [value]="wellName">
                                        {{wellName }}
                                    </mat-option>
                                </ng-container>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </div>
            </ng-container>
    
            <div class="w-48 mr-4" [ngClass]="{'w-56' : filterData.startDate != null}">
                <mat-form-field class="w-full">
                    <input matInput [matDatepicker]="picker" [(ngModel)]="filterData.startDate"
                        (dateChange)="onDateSelected($event)" placeholder="Submission Date">
    
                    <button *ngIf="filterData.startDate != null" matSuffix mat-icon-button style="color:red"
                        (click)="resetDate()">
                        <mat-icon style="color: rgb(250, 113, 113);">clear</mat-icon>
                    </button>
    
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>

            <button
                class="btn btn-outline btn-default"
                (click)="reset()">
                Reset
            </button>
            <button
                class="btn btn-outline btn-default mx-2 hover:text-white"
                (click)="refresh()">
                <mat-icon
                    class="text-primary hover:text-white"
                    svgIcon="heroicons_solid:arrow-path">
                </mat-icon>
            </button>
        </div>
    </div>

    <div class="overflow-x-auto">
        <table class="table table-zebra text-center">
            <thead>
                <tr class="tableHeader-bg-color">
                    <td></td>
                    <th class="text-center" colspan="4"> Previous Day Report </th>
                    <th class="text-center" colspan="4"> Latest Report </th>
                    <td></td>
                </tr>

                <tr class="tableHeader-bg-color">
                    <td class="w-32"> Well Name </td>

                    <td> Previous Day Report <br> Generation status </td>
                    <td> Previous Day Report <br> Submission Status </td>
                    <td> Previous Day <br> Report Date </td>
                    <td> Submission <br> timestamp </td>

                    <td> Latest Report <br> Generation Status </td>
                    <td> Latest Report <br> Submission Status </td>
                    <td> Latest Day <br> Report Date </td>
                    <td> Submission <br> timestamp </td>

                    <td> Report type </td>
                </tr>
            </thead>
            <ng-container *ngIf="(auditTrailsData$ | async) as auditTrailsData">
                <tbody *ngIf="auditTrailsData.data && auditTrailsData.data.totalRecords > 0; else noData">
                    <tr *ngFor="let item of auditTrailsData.data.data">
                        <td>{{ item.wellName }}</td>
                        <td>
                            <div [ngClass]="{
                                'successBadge': item.previousStatus.generationStatus === 'Success',
                                'failedBadge': item.previousStatus.generationStatus === 'Pending'
                              }">
                                {{ item.previousStatus.generationStatus ?? "" }}
                            </div>
                        </td>
                        <td>
                            <div [ngClass]="{
                                'successBadge': item.previousStatus.submissionStatus === 'Success',
                                'failedBadge': item.previousStatus.submissionStatus === 'Pending'
                              }">
                                {{ item.previousStatus.submissionStatus ?? "" }}
                            </div>
                        </td>
                        <td>{{ handleFormatDate(item.previousStatus.date,false) }}</td>
                        <td>{{ handleFormatDate(item.previousStatus.submissionTimestamp) }}</td>

                        <td>
                            <div [ngClass]="{
                                'successBadge': item.latestStatus.generationStatus === 'Success',
                                'failedBadge': item.latestStatus.generationStatus === 'Pending'
                              }">
                                {{ item.latestStatus.generationStatus ?? ""}}
                            </div>
                        </td>
                        <td>
                            <div [ngClass]="{
                                'successBadge': item.latestStatus.submissionStatus === 'Success',
                                'failedBadge': item.latestStatus.submissionStatus === 'Pending'
                              }">
                                {{ item.latestStatus.submissionStatus ?? "" }}
                            </div>
                        </td>

                        <td>{{ handleFormatDate(item.latestStatus.date,false) }}</td>
                        <td>{{ handleFormatDate(item.latestStatus.submissionTimestamp) }}</td>

                        <td>{{ item.reportType ?? "" }}</td>
                    </tr>
                </tbody>

                <ng-template #noData>
                    <tr>
                        <td style="background-color: #f5f5f5;" colspan="10">No data available</td>
                    </tr>
                </ng-template>
            </ng-container>
        </table>
    </div>

    <!-- pagination -->
    <div class="divider mt-2"></div>
    <div class="join flex justify-between w-full">
        <button [disabled]="filterData.pageNumber <= 1" class="join-item btn btn-remove-bg" (click)="previousPage()">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-long-left'"></mat-icon>
            Previous</button>
        <button class="join-item">Page {{ filterData.pageNumber }}</button>
        <button [disabled]=" auditTrailsData.totalPages <= filterData.pageNumber" class="join-item btn btn-remove-bg"
            (click)="nextPage()">
            Next
            <mat-icon [svgIcon]="'heroicons_outline:arrow-long-right'"></mat-icon>
        </button>
    </div>
</div>